export const collapseTemplate = [
  { header: 'generateReport.dataToResult.report.general.document_version' },
  { header: 'generateReport.dataToResult.report.general.id_ensaio' },
  { header: 'generateReport.dataToResult.report.general.id_hex' },
  { header: 'generateReport.dataToResult.report.general.product' },
  { header: 'generateReport.dataToResult.report.general.product_version' },
  { header: 'generateReport.dataToResult.report.general.date_authorised' },
  { header: 'generateReport.dataToResult.report.general.observacao_geral' },
  { header: 'generateReport.dataToResult.report.general.text_comentario' },
  { header: 'generateReport.dataToResult.report.general.desc_projeto' },
  { header: 'generateReport.dataToResult.report.general.planta_origem' },
  { header: 'generateReport.dataToResult.report.general.data_cadastro' },
  { header: 'generateReport.dataToResult.report.general.desc_cliente' },
  { header: 'generateReport.dataToResult.report.general.descricao_mes' },
  { header: 'generateReport.dataToResult.report.general.pedido' },
  { header: 'generateReport.dataToResult.report.general.item' },
  { header: 'generateReport.dataToResult.report.general.corrida' },
  { header: 'generateReport.dataToResult.report.general.ordem_de_processo' },
  { header: 'generateReport.dataToResult.report.general.lote_tt' },
  { header: 'generateReport.dataToResult.report.general.ippn' },
  { header: 'generateReport.dataToResult.report.general.posicao_amostra' },

  {
    header:
      'generateReport.dataToResult.report.test.collapse.comprimento_amostra_ca',
  },
  {
    header:
      'generateReport.dataToResult.report.test.collapse.reg_fal_longitudinal',
  },
  {
    header:
      'generateReport.dataToResult.report.test.collapse.reg_fal_transversal',
  },
  { header: 'generateReport.dataToResult.report.test.collapse.teste_colapso' },
  {
    header:
      'generateReport.dataToResult.report.test.collapse.teste_colapso_psi',
  },
  {
    header:
      'generateReport.dataToResult.report.test.collapse.tempopressaoteste',
  },
  {
    header:
      'generateReport.dataToResult.report.test.collapse.resultado_colapso',
  },
  { header: 'generateReport.dataToResult.report.test.collapse.req_min' },
  { header: 'generateReport.dataToResult.report.test.collapse.req_min_psi' },

  { header: 'generateReport.dataToResult.report.test.collapse.a1_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.b1_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.c1_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.d1_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.e1_valor' },

  { header: 'generateReport.dataToResult.report.test.collapse.a2_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.b2_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.c2_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.d2_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.e2_valor' },

  { header: 'generateReport.dataToResult.report.test.collapse.a3_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.b3_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.c3_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.d3_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.e3_valor' },

  { header: 'generateReport.dataToResult.report.test.collapse.a4_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.b4_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.c4_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.d4_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.e4_valor' },

  { header: 'generateReport.dataToResult.report.test.collapse.a5_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.b5_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.c5_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.d5_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.e5_valor' },

  { header: 'generateReport.dataToResult.report.test.collapse.a6_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.b6_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.c6_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.d6_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.e6_valor' },

  { header: 'generateReport.dataToResult.report.test.collapse.a7_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.b7_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.c7_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.d7_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.e7_valor' },

  { header: 'generateReport.dataToResult.report.test.collapse.a8_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.b8_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.c8_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.d8_valor' },
  { header: 'generateReport.dataToResult.report.test.collapse.e8_valor' },

  { header: 'generateReport.dataToResult.report.test.collapse.a_media' },
  { header: 'generateReport.dataToResult.report.test.collapse.b_media' },
  { header: 'generateReport.dataToResult.report.test.collapse.c_media' },
  { header: 'generateReport.dataToResult.report.test.collapse.d_media' },
  { header: 'generateReport.dataToResult.report.test.collapse.e_media' },

  { header: 'generateReport.dataToResult.report.test.collapse.wt_media' },
  { header: 'generateReport.dataToResult.report.test.collapse.ec_media' },

  { header: 'generateReport.dataToResult.report.test.collapse.a_ec' },
  { header: 'generateReport.dataToResult.report.test.collapse.b_ec' },
  { header: 'generateReport.dataToResult.report.test.collapse.c_ec' },
  { header: 'generateReport.dataToResult.report.test.collapse.d_ec' },
  { header: 'generateReport.dataToResult.report.test.collapse.e_ec' },

  { header: 'generateReport.dataToResult.report.test.collapse.a_oval_min' },
  { header: 'generateReport.dataToResult.report.test.collapse.b_oval_min' },
  { header: 'generateReport.dataToResult.report.test.collapse.c_oval_min' },
  { header: 'generateReport.dataToResult.report.test.collapse.d_oval_min' },
  { header: 'generateReport.dataToResult.report.test.collapse.e_oval_min' },

  { header: 'generateReport.dataToResult.report.test.collapse.a_oval_max' },
  { header: 'generateReport.dataToResult.report.test.collapse.b_oval_max' },
  { header: 'generateReport.dataToResult.report.test.collapse.c_oval_max' },
  { header: 'generateReport.dataToResult.report.test.collapse.d_oval_max' },
  { header: 'generateReport.dataToResult.report.test.collapse.e_oval_max' },

  { header: 'generateReport.dataToResult.report.test.collapse.a_fita_pi' },
  { header: 'generateReport.dataToResult.report.test.collapse.b_fita_pi' },
  { header: 'generateReport.dataToResult.report.test.collapse.c_fita_pi' },
  { header: 'generateReport.dataToResult.report.test.collapse.d_fita_pi' },
  { header: 'generateReport.dataToResult.report.test.collapse.e_fita_pi' },

  { header: 'generateReport.dataToResult.report.test.collapse.od_media' },
  { header: 'generateReport.dataToResult.report.test.collapse.oval_media' },

  { header: 'generateReport.dataToResult.report.test.collapse.a_ov' },
  { header: 'generateReport.dataToResult.report.test.collapse.b_ov' },
  { header: 'generateReport.dataToResult.report.test.collapse.c_ov' },
  { header: 'generateReport.dataToResult.report.test.collapse.d_ov' },
  { header: 'generateReport.dataToResult.report.test.collapse.e_ov' },

  { header: 'generateReport.dataToResult.report.test.collapse.inst_ffita_p' },
  { header: 'generateReport.dataToResult.report.test.collapse.drao_esca' },
  { header: 'generateReport.dataToResult.report.test.collapse.inst_trans' },
  { header: 'generateReport.dataToResult.report.test.collapse.inst_trena' },
  { header: 'generateReport.dataToResult.report.test.collapse.inst_relog' },
  { header: 'generateReport.dataToResult.report.test.collapse.inst_us_ma' },

  {
    header:
      'generateReport.dataToResult.report.test.collapse.inst_next_calib_ffita_p',
  },
  {
    header:
      'generateReport.dataToResult.report.test.collapse.inst_next_calib_drao_esca',
  },
  {
    header:
      'generateReport.dataToResult.report.test.collapse.inst_next_calib_trans',
  },
  {
    header:
      'generateReport.dataToResult.report.test.collapse.inst_next_calib_trena',
  },
  {
    header:
      'generateReport.dataToResult.report.test.collapse.inst_next_calib_relog',
  },
  {
    header:
      'generateReport.dataToResult.report.test.collapse.inst_next_calib_us_ma',
  },
]
